import React, { useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from '../../shared/components/common/loader/Loader';
import { changeActiveAccount } from '../../shared/services/user/UserService';
import { PROJECTS } from '../../shared/routes/path';

/**
 * Cel linku z maila z zaproszeniem: przestawia panel na konto, do którego zaproszono, i wchodzi na
 * listę projektów.
 *
 * Bez tego użytkownik z kilkoma workspace'ami lądował w tym, w którym był ostatnio, i musiał sam
 * zgadywać, czego dotyczyło zaproszenie.
 *
 * Id konta w adresie niczego nie otwiera: `changeActiveAccount` przestawia konto TYLKO na takie,
 * w którym użytkownik ma członkostwo, więc najgorsze, co można zrobić cudzym linkiem, to przejść
 * na własne konto. Trasa jest prywatna, więc niezalogowany trafia najpierw na logowanie i wraca
 * tutaj (`LoginPage` czyta `state.from`).
 */
const InviteAcceptPage: React.FC = () => {
  const { accountId } = useParams();
  const navigate = useNavigate();
  // StrictMode montuje efekty dwa razy; drugie przejście przeładowałoby stronę w trakcie pierwszego.
  const handledRef = useRef(false);

  useEffect(() => {
    if (handledRef.current) {
      return;
    }
    handledRef.current = true;

    const targetAccountId = Number(accountId);
    if (!Number.isInteger(targetAccountId) || targetAccountId <= 0) {
      navigate(PROJECTS, { replace: true });
      return;
    }

    changeActiveAccount(targetAccountId)
      // Pełne przeładowanie, tak samo jak przełącznik kont w `LoginBox`: aktywne konto siedzi
      // w kontekstach, cache'u zapytań i tokenie, a przeładowanie jest jedynym sposobem, żeby
      // wszystkie zaczęły od tej samej prawdy.
      .then(() => window.location.replace(PROJECTS))
      .catch(() => navigate(PROJECTS, { replace: true }));
  }, [accountId, navigate]);

  return <Loader />;
};

export default InviteAcceptPage;
